import { NgModule } from '@angular/core';
import { RoofPlanRoutingModule } from './roof-plan-routing.module';




@NgModule({
  declarations: [],
  imports: [
    RoofPlanRoutingModule
  ]
})
export class RoofPlanModule { }
